<template>
  <div class="exhibition">
    <div class="title">产品展示</div>
    <div class="content">
      <div v-for="(item, index) in images" :key="index" class="showPics">
        <img :src="item" alt="产品展示" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Exhibition',
  data() {
    return {
      images: [
        require('@/assets/images/product/oversea.jpg'),
        require('@/assets/images/product/aircraft.jpg'),
        require('@/assets/images/product/ship.jpg'),
        require('@/assets/images/product/train.jpg'),
        require('@/assets/images/product/truck.jpg')
      ]
    }
  }
}
</script>

<style scoped>
.title {
  margin-top: 100px;
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  color: #000000;
}

.content {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 25px 30px;
  margin-top: 30px;
  background-color: rgb(220, 220, 220);
}

.showPics {
  padding: 0 10px;
}

.showPics > img {
  display: block;
  height: 100%;
  width: 100%;
}
</style>
